/**
 * @ngdoc controllers
 * @memberof mercury.modules.cogs
 * @name ReportsCogsProductCtrl
 * @description A report with sales grouped by Item Category and report interval
 */
angular.module('mercury.modules.reports.cogs')
.controller('ReportsCogsProductCtrl', ["dialog", "title", "reporttime", "ReportCogs", "ReportPosItems", "ReportsCogsProductService", "$scope", "$state", "$stateParams", "$q", "userinfo", function(dialog, title, reporttime, ReportCogs,
  ReportPosItems, ReportsCogsProductService, $scope, $state, $stateParams, $q, userinfo) {

  title.set('Products');

  $scope.chartColumns = [
    {label: 'Product', type: 'string', key: 'posItemName'},
    {label: 'Cost of Goods Gross Margin', type: 'number', key: 'grossMargin', filter: 'currency'}
  ];

  $scope.allowCogsCostAnalysis = userinfo.companyHasPermission('Stock');

  $scope.loadData = function() {
    var allResults;
    $scope.reportData = [];
    $scope.categories = [
      {values: [], key: 'All'}
    ];

    if ($stateParams.selectedCategoryIds) {
      $scope.selectedCategoryIds = $stateParams.selectedCategoryIds || $scope.categories[0].values;
    } else {
      $scope.selectedCategoryIds = $scope.categories[0].values;
    }

    $scope.loading = $q.all({
      categories: ReportPosItems.itemCategories(),
      reportData: ReportCogs.getProductsDetail(reporttime.start(), reporttime.end())
    });

    $scope.loading.then(function(result) {

      result.categories.forEach(function(cat) {
        $scope.categories.push(cat);
      });

      allResults = result.reportData;
      $scope.setCategory();
    });

    $scope.setCategory = function() {
      let selectedCategoryNames = [...$scope.selectedCategoryIds];
      if(selectedCategoryNames.length > 0) {
        const category = $scope.categories.find(c => c.values && c.values.includes($scope.selectedCategoryIds[0]));
        if(category) {
          selectedCategoryNames = [category.key];
        }
      }
    
      $scope.reportData = ReportsCogsProductService.parseResults(allResults, selectedCategoryNames);
    };
  };

  $scope.loadData();

  $scope.showPosItemLinkDialog = function(itemId, itemName) {
    dialog.open({
      backdrop: 'static',
      templateUrl: 'modules/reports/cogs/positemlink.tpl.html',
      controller: 'ReportsCogsPosItemLinksCtrl',
      size: 'xl',
      resolve: {
        dialogData: function() {
          return {
            posItemId: itemId,
            posItemName: itemName
          };
        }
      }
    }).then(function(dialogResults) {
      if (dialogResults && dialogResults.cogsChanged === true) {
        $scope.loadData();
      }
    });
  };
}]);
